import { useLogin } from "api/Auth/auth";
import { Spinner } from "components";
import { createAlert } from "components/Alert/Alert";
import InputField from "components/InputField/InputField";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import smartLogo from "./../../../assets/images/logo512.png";
import { useSelector } from "react-redux";

export default function Login() {
  const { role } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { mutate: login, isPending } = useLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    if (role === "admin") {
      navigate("/dashboard");
    }
    if (role === "customer") {
      navigate("/control-panel");
    }
  }, [role, navigate]); // يتم التنقل إذا تغيّر الـ role أو navigate

  const handleSubmitLogin = async (e) => {
    e.preventDefault();

    if (email === "" || password === "") {
      createAlert("Warning", "جميع الحقول مطلوبة.");
      return;
    }

    if (password.length < 8) {
      createAlert("Warning", "كلمة المرور يجب ان تكون اكثر من 8 محارف.");
      return;
    }

    login({ email, password });
  };

  return (
    <div
      className="flex justify-center items-center w-full md:p-2 overflow-hidden"
      id="login-page"
    >
      {/* <div
        className="absolute z-0 w-full max-w-3xl top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-[385px] bg-gradient-to-r from-green-500 to-green-500 shadow-lg transform 
      -skew-y-6 md:skew-y-0 md:-rotate-3 md:rounded-md"
      ></div> */}

      <section className="grid md:grid-cols-2 w-full relative max-w-3xl p-6 mx-auto bg-mainLight md:rounded-3xl shadow-md dark:bg-gray-800 my-auto md:my-6 h-[370px]">
        <div className="flex flex-col gap-4">
          <h2 className="text-xl font-bold text-white dark:text-white">
            تسجيل الدخول
          </h2>
          <form onSubmit={handleSubmitLogin} className="flex flex-col gap-4">
            <InputField
              title={"البريد الالكتروني أو رقم الموبايل"}
              id="emailAddress"
              type="text"
              value={email}
              onChange={(e) => setEmail(e.value)}
              direction="ltr"
            />

            <InputField
              title={"كلمة المرور"}
              id="password"
              type={"password"}
              value={password}
              onChange={(e) => setPassword(e.value)}
              direction="ltr"
            />
            <div className="flex flex-col gap-1">
              <span className="text-sm text-white dark:text-gray-100">
                ليس لديك حساب؟{" "}
                <Link
                  className="text-green-400 hover:underline font-bold"
                  to={"/register"}
                >
                  سجل هنا
                </Link>
              </span>
              <span className="text-sm text-white dark:text-gray-100">
                نسيت كلمة السر؟{" "}
                <Link
                  className="text-green-400 hover:underline font-bold"
                  to={"/forgot-my-password"}
                >
                  اضغط هنا
                </Link>
              </span>
            </div>
            {!isPending ? (
              <button className="px-6 py-2 leading-5 w-28 mx-auto text-white transition-colors duration-200 transform bg-green-500 rounded-2xl hover:bg-green-600 focus:outline-none ">
                دخول
              </button>
            ) : (
              <Spinner />
            )}
          </form>
        </div>

        <div className="hidden md:block m-auto">
          <img src={smartLogo} alt="" className="m-auto max-w-72" />
        </div>
      </section>
    </div>
  );
}
